import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
import { registerServiceWorker, watchForInstall } from "./lib/install";

// The list has to open in a shop with no signal, and on iOS a worker is the
// precondition for ever receiving a reminder (#1332).
registerServiceWorker();
watchForInstall();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A taste profile is stable for years and a meal library changes on
      // deploy. Refetching either on every window focus is pure noise.
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      retry: 1,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
